module.exports = __webpack_public_path__ + "img/dollars.9a96510f.svg";